"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StandaloneTokenProvider = void 0;
var _react = require("react");
var _TokenService = require("../TokenService");
var _constants = require("../constants");
var _internals = require("../internals");
var _logger = require("../logger");
var _tokenContext = require("./tokenContext");
var _jsxRuntime = require("react/jsx-runtime");
const logger = _logger.mainLogger.createChild('StandaloneTokenProvider');

// TODO: true customerId, when logged in, is not always known at the start of application that uses this provider (case of SSG)
// This opts user out of their true user token since this provider does not try to fetch it and just fetches/returns public token when unathorized customerId is provided
/** @deprecated Use `UniversalTokenProvider` instead */
const StandaloneTokenProvider = ({
  children,
  token,
  customerId
}) => {
  const [clientToken, setClientToken] = (0, _react.useState)(token ? (0, _internals.cleanToken)(token) : undefined);
  const [isAnonymous, setIsAnonymous] = (0, _react.useState)(true);
  const [isUserVerified, setIsUserVerified] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    if (token) {
      setClientToken(token);
    } else {
      const fetchToken = async () => {
        const fetchedToken = await _TokenService.TokenService.getInstance().getAuthorizationToken(customerId);
        setClientToken(fetchedToken);
      };
      fetchToken().catch(error => {
        logger.error(new Error('Fetching token failed', {
          cause: error
        }));
        setClientToken('');
      }).finally(() => setIsUserVerified(true));
    }
  }, [customerId, token]);
  (0, _react.useEffect)(() => {
    if (customerId === _constants.NOT_LOGGED_IN_USER_ID) {
      setIsAnonymous(true);
    } else {
      setIsAnonymous(false);
    }
  }, [customerId]);
  (0, _react.useEffect)(() => {
    const remainder = (0, _internals.getRemainingSeconds)(clientToken ?? '');

    // in the future, we will want to refresh the token here when the token is about to expire; for now, we are just writing a warning to the console.
    const timer = setTimeout(() => {
      logger.info('Your access token has expired. Please reload the page to acquire a new one.');
    }, remainder * 1000);
    return () => clearTimeout(timer);
  }, [clientToken]);
  const tokenValue = (0, _internals.cleanToken)(clientToken ?? '');
  const contextValue = (0, _react.useMemo)(() => ({
    token: tokenValue,
    customerId,
    formattedToken: tokenValue ? `Bearer ${tokenValue}` : '',
    isAnonymousUser: isAnonymous,
    isUserVerified
  }), [customerId, isAnonymous, isUserVerified, tokenValue]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_tokenContext.tokenContext.Provider, {
    value: contextValue,
    children: children
  });
};
exports.StandaloneTokenProvider = StandaloneTokenProvider;
